import { render, staticRenderFns } from "./SectionHeaderNews.vue?vue&type=template&id=56ff814c"
import script from "./SectionHeaderNews.vue?vue&type=script&lang=js"
export * from "./SectionHeaderNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports